import { Box } from '@mui/material';
import { Loader } from 'components';
import { useConfigContext } from 'hooks';
import { injectIntl } from 'react-intl';
import { ComonUtils } from 'services/comon';
import { StudentActioner, StudentUtils } from 'services/student';
import { StudentForm } from './StudentForm';

function StudentCreateComponent({ intl, ...props }) {
  const { campaign, site } = useConfigContext();
  function createForm(templates, studentsTemplates, values = {}, isRegister = false) {
    return <StudentForm templates={templates} studentsTemplates={studentsTemplates} values={values} mode={'create'} isRegister={isRegister} />;
  }

  function renderCreateForm(render) {
    const promises = [ComonUtils.getComonTemplates(), StudentUtils.getStudentTemplates(campaign, site)];
    const isDuplicate = props?.location?.state?.duplicate;
    const isRegister = props?.location?.state?.register;

    if (isDuplicate || isRegister) {
      promises.push(StudentActioner.get(props.location.state.id));
    }
    Promise.all(promises).then(([templates, studentsTemplates, values]) => {
      if (values === undefined) {
        render(createForm(templates, studentsTemplates));
      } else {
        delete values._id;
        values.workshop.workshop_managments = [];
        if (isDuplicate) {
          delete values.uuid;
        }
        render(createForm(templates, studentsTemplates, values, isRegister));
      }
    });
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" className="full-width">
      <h2>{intl.messages.scenes.student.create.title}</h2>
      <Loader render={renderCreateForm} />
    </Box>
  );
}

const StudentCreate = injectIntl(StudentCreateComponent);

export { StudentCreate };
